import React from 'react';
import {
  useTheme,
  Icon,
  Stack,
  Text,
  VStack,
  Wrap,
  Box,
} from '@wegroup/design-system';
import convertKeyToIconName from '../../../../../../common/src/utils/convertKeyToIconName';

interface Props {
  Logo?: React.ReactElement;
  insuranceCompany?: string;
  insurance?: string;
  price?: string;
  options?: string[];
}

const ComparisonBarItemContent: React.FC<React.PropsWithChildren<Props>> = ({
  Logo,
  insuranceCompany,
  insurance,
  price,
  options,
}) => {
  const { colors } = useTheme();

  return (
    <Stack
      flexDir={{
        laptopL: 'column',
      }}
      align="center"
      justify="space-between"
      spacing="2"
      w="100%"
    >
      <VStack align={{ base: 'flex-start', laptopL: 'center' }}>
        <Text
          textStyle="normalBodyBold"
          display={{
            laptopL: 'none',
          }}
        >
          {insuranceCompany}
        </Text>
        <Box
          display={{
            base: 'none',
            laptopL: 'block',
          }}
          h="8"
        >
          {Logo ? Logo : insuranceCompany}
        </Box>
        <Text
          textAlign={{
            base: 'left',
            laptopL: 'center',
          }}
        >
          {insurance}
        </Text>
      </VStack>
      <Text textStyle="normalBodyBold">{price}</Text>
      <Wrap
        display={{
          base: 'none',
          desktopS: 'flex',
        }}
        justify="center"
      >
        {options?.map((option, index) => (
          <Icon
            key={index}
            name={convertKeyToIconName(option)}
            color={colors.primary[500]}
          />
        ))}
      </Wrap>
    </Stack>
  );
};

export default ComparisonBarItemContent;
